module.exports = __webpack_public_path__ + "img/image1.3f31b991.png";